import { CreateCharacterState } from "../slice";
import { imgAvatar, imgLogo2 } from "@/shared/assets/img";

export default function CreateCharacterUserInfo({
  firstName,
  lastName,
  gender,
  age,
}: CreateCharacterState["personalData"]) {
  const info = (label: string, value: string, withSeparate?: boolean) => (
    <div className="flex items-center justify-between gap-2 relative h-10 pb-px overflow-hidden">
      <div className="text-white/70 font-medium whitespace-nowrap">{label}:</div>
      <div className="font-bold truncate">{value}</div>
      {withSeparate && (
        <div className="absolute bottom-0 w-full h-px bg-gradient-to-r from-inverted to-inverted/20 opacity-10" />
      )}
    </div>
  );
  return (
    <div className="absolute top-[--boundary-offset-x] mt-14 left-[--boundary-offset-x] overflow-hidden gap-5 flex w-97.5 card card-size-sm">
      <div className="card-inner-light dark:bg-gradient-to-br from-accent-muted/30 to-40% w-60" />
      <div className="w-25">
        <div className="rounded-2xl w-25 aspect-square relative p-1.5 mb-3">
          <div className="rounded-border" />
          <img src={imgAvatar} alt="asdsad" className="w-full h-full object-cover rounded-lg" />
        </div>
        <div>
          <img src={imgLogo2} alt="Logo" className="h-5 mx-auto" />
        </div>
      </div>
      <div className="grow -my-2.5 overflow-hidden">
        {info("Имя", firstName, true)}
        {info("Фамилия", lastName, true)}
        {info("Пол", gender, true)}
        {info("Возраст", String(age))}
      </div>
    </div>
  );
}
